import { getHomadConfig } from './config';
import { translateHomadEvents } from './eventbus';
import homadLib from './lib';

export function initializeHomadLib(aabConfig, onReady) {
    const SvpPlayer = (window.SVP && window.SVP.Player) || {};
    if (!SvpPlayer.isHomadLoaded) {
        SvpPlayer.isHomadLoaded = true;

        translateHomadEvents();
        const homadConfig = getHomadConfig(aabConfig, onReady);
        homadLib(homadConfig);
    }
}
